import React, { ChangeEvent } from 'react';
import { joiPasswordExtendCore } from 'joi-password';
import Joi from 'joi';

import Form from '../common/form';
import PasswordStrength from '../blocks/password-strength';
import Progress from '../themed/progress';

import * as userService from '../../services/userService';
import * as toastService from '../../services/toastService';
import * as utils from '../../utils/utilities';

import withRouter from '../hoc/withRouter';

import routes from '../../utils/routes';
import {
	MAX_PASSWORD_LENGTH,
	MIN_PASSWORD_LENGTH,
} from '../../utils/constants';

class ChangePasswordForm extends Form {
	state = {
		data: {
			password: '',
			confirmPassword: '',
		},
		errors: {},
		loading: false,
		progress: 0,
		states: [],
		cities: [],
	};

	schema = {
		password: Joi.extend(joiPasswordExtendCore)
			.string()
			.min(MIN_PASSWORD_LENGTH)
			.max(MAX_PASSWORD_LENGTH)
			.minOfSpecialCharacters(1)
			.minOfLowercase(1)
			.minOfUppercase(1)
			.minOfNumeric(1)
			.noWhiteSpaces()
			.required()
			.label('New Password'),
		confirmPassword: Joi.string()
			.equal(Joi.ref('password'))
			.required()
			.label('Confirm Password')
			.options({ messages: { 'any.only': '{{#label}} does not match' } }),
	};

	getPageParams = (): { code: string } | null => {
		const code = this.props.searchParams[0].get('code') || '';
		return { code };
	};

	handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
		this.handleChange(event);

		const confirmPassword: string = event.target.value;
		const isMatch: boolean = this.state.data.password === confirmPassword;

		if (isMatch) {
			const errors = { ...this.state.errors } as any;
			delete errors.confirmPassword;

			this.setState({ errors });
		}
	};

	getApiData = () => {
		const pageParams = this.getPageParams();
		if (!pageParams) return null;

		const apiData: any = { ...this.state.data, ...pageParams };
		return apiData;
	};

	postData = async (): Promise<void> => {
		const apiData = this.getApiData();
		await userService.setPassword(apiData, this.handleProgressChange);

		window.location.href = routes.login.fullPath;
	};

	doSubmit = (): void => {
		const pageParams = this.getPageParams();
		if (!pageParams) return toastService.error('Token not found!');

		toastService.promise(this.postData(), {
			loading: 'Updating Password',
			success: 'Password Updated',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					{this.renderInput({
						type: 'password',
						name: 'password',
						label: 'New Password',
						placeholder: 'Choose a Password',
					})}

					<PasswordStrength password={this.state.data.password} />

					{this.renderInput({
						type: 'password',
						name: 'confirmPassword',
						label: 'Confirm Password',
						placeholder: 'Confirm Your Chosen Password',
						onChange: this.handlePasswordChange,
					})}

					<div className="d-flex justify-content-end mt-4">
						{this.renderButton('Reset Password')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default withRouter(ChangePasswordForm);
